import type { SupVaultReward } from "@/types/vault";

export const POINTS_AMOUNT_REWARD = {
  special: 20,
  regular: 5,
};

export const CRED_REWARD = {
  type: "points",
  address: "0x0000000000000000000000000000000000000000",
  logo: "/assets/img/sp.svg",
  symbol: "Superform Points",
  reward_rate: 0,
  rate_type: "earning",
  chain_id: 1,
  is_configurable: false,
  total_supply: null,
  reward_multiplier: POINTS_AMOUNT_REWARD.regular,
  remarks: "",
  remarks_url: "",
} as SupVaultReward;

export const CRED_SUPERVAULT_REWARD = {
  ...CRED_REWARD,
  reward_multiplier: POINTS_AMOUNT_REWARD.special,
} as SupVaultReward;

export const SPECIAL_POINT_PROTOCOLS = [
  "Hdxs_d4Krk48Q81CMtg9E", // animal farm
  "_gIpnQXdrJf2wp8UVs6Sh", // superform
];
